const credentials = {
  Candidate: {
    show: false,
    definition: 'Counselor',
  },
  'Counselor Under Supervision': {
    show: true,
    definition: 'Counselor Under Supervision',
  },
  CPC: {
    show: true,
    definition: 'Certified Professional Counselor',
  },
  'CPC-S': {
    show: true,
    definition: 'Certified Professional Counselor Supervisor',
  },
  DNP: {
    show: true,
    definition: 'Doctor of Nursing Practice',
  },
  DO: {
    show: true,
    definition: 'Doctor of Osteopathic Medicine',
  },
  'In Process of LCMHC': {
    show: false,
    definition: 'Counselor',
  },
  'In Process of LCSW': {
    show: false,
    definition: 'Counselor',
  },
  'In Process of LPC': {
    show: false,
    definition: 'Counselor',
  },
  Intern: {
    show: false,
    definition: 'Counselor',
  },
  LAMFT: {
    show: true,
    definition: 'Licensed Associate Marriage Family Therapist',
  },
  LAPC: {
    show: true,
    definition: 'Licensed Associated Professional Counselor',
  },
  LCADC: {
    show: true,
    definition: 'Licensed Clinical Alcohol & Drug Counselor',
  },
  LCMHA: {
    show: true,
    definition: 'Licensed Clinical Mental Health Associate',
  },
  LCMHC: {
    show: true,
    definition: 'Licensed Clinical Mental Health Counselor',
  },
  'LCMHC-A': {
    show: true,
    definition: 'Licensed Clinical Mental Health Counselor Associate',
  },
  'LCMHC-S': {
    show: true,
    definition: 'Licensed Clinical Mental Health Counselor Supervisor',
  },
  LCMHCA: {
    show: true,
    definition: 'Licensed Clinical Mental Health Counselor - Associate',
  },
  LCP: {
    show: true,
    definition: 'Licensed Clinical Psychologist',
  },
  LCPC: {
    show: true,
    definition: 'Licensed Clinical Professional Counselor',
  },
  LCSW: {
    show: true,
    definition: 'Licensed Clinical Social Worker',
  },
  'LCSW-A': {
    show: true,
    definition: 'Licensed Clinical Social Worker - Associate',
  },
  'LCSW-BACS': {
    show: true,
    definition:
      'Licensed Clinical Social Worker, Board-Approved Clinical Supervisor',
  },
  'LCSW-C': {
    show: true,
    definition: 'Licensed Clinical Social Worker - Candidate',
  },
  'LCSW-Certified': {
    show: true,
    definition: 'Licensed Clinical Social Worker - Certified',
  },
  'LCSW-R': {
    show: true,
    definition: 'Licensed Clinical Social Worker - Candidate',
  },
  'LCSW-S': {
    show: true,
    definition: 'Licensed Clinical Social Worker - Supervisor',
  },
  LCSWA: {
    show: true,
    definition: 'Licensed Clinical Social Worker Associate',
  },
  LGPC: {
    show: true,
    definition: 'Licensed Graduate Professional Counselor',
  },
  'Licensed Associate Counselor': {
    show: false,
    definition: 'Licensed Associate Counselor',
  },
  'Licensed Clinical Psychologist': {
    show: false,
    definition: 'Licensed Clinical Psychologist',
  },
  LICSW: {
    show: true,
    definition: 'Licensed Independent Clinical Social Worker',
  },
  "Limited Master's Social Worker": {
    show: false,
    definition: "Limited Master's Social Worker",
  },
  'Limited Professional Counselor': {
    show: false,
    definition: 'Limited Professional Counselor',
  },
  LISW: {
    show: true,
    definition: 'Licensed Independent Social Worker',
  },
  'LISW-CP': {
    show: true,
    definition: 'Licensed Independent Social Worker - Clinical Practice',
  },
  'LISW-S': {
    show: true,
    definition: 'Licensed Independent Social Worker - Supervisor',
  },
  LLP: {
    show: true,
    definition: 'Limited Licensed Psychologist',
  },
  LLPC: {
    show: true,
    definition: 'Limited Licensed Professional Counselor',
  },
  LMFT: {
    show: true,
    definition: 'Licensed Marriage & Family Therapist',
  },
  'LMFT-A': {
    show: true,
    definition: 'Licensed Marriage & Family Therapist - Associate',
  },
  LMFTC: {
    show: true,
    definition: 'Licensed Marriage & Family Therapist - Candidate',
  },
  LMHC: {
    show: true,
    definition: 'Licensed Mental Health Counselor',
  },
  LMSW: {
    show: true,
    definition: 'Licensed Master Social Worker',
  },
  'LMSW-C': {
    show: true,
    definition: 'Licensed Master Social Worker - Candidate',
  },
  'LMSW-Clinical': {
    show: true,
    definition: 'Licensed Master Social Worker - Clinical',
  },
  LPC: {
    show: true,
    definition: 'Licensed Professional Counselor',
  },
  'LPC - Associate': {
    show: false,
    definition: 'Licensed Professional Counselor',
  },
  'LPC - Candidate': {
    show: false,
    definition: 'Licensed Professional Counselor',
  },
  'LPC-MHSP': {
    show: true,
    definition:
      'Licensed Professional Counselor, Mental Health Service Provider',
  },
  'LPC-S': {
    show: true,
    definition: 'Licensed Professional Counselor - Supervisor',
  },
  'LPC-SA': {
    show: true,
    definition: 'Licensed Professional Counselor - Supervisor Appraisal',
  },
  LPCA: {
    show: true,
    definition: 'Licensed Professional Counselor Associate',
  },
  LPCC: {
    show: true,
    definition: 'Licensed Professional Clinical Counselor of Mental Health',
  },
  'LPCC-S': {
    show: true,
    definition: 'Licensed Professional Clinical Counselor - Supervisor',
  },
  LPCMH: {
    show: true,
    definition: 'Licensed Professional Counselor of Mental Health',
  },
  'LPE-I': {
    show: true,
    definition: 'Licensed Psychological Examiner - Independent',
  },
  LSCW: {
    show: true,
    definition: 'Licensed Clinical Social Worker',
  },
  LSW: {
    show: true,
    definition: 'Licensed Social Worker',
  },
  'LSW - Candidate': {
    show: false,
    definition: 'Licensed Social Worker',
  },
  'Masters Level Clinician': {
    show: true,
    definition: 'Masters Level Clinician',
  },
  MD: {
    show: true,
    definition: 'Psychiatrist, Medical Doctor',
  },
  NP: {
    show: true,
    definition: 'Nurse Practitioner ',
  },
  PMHNP: {
    show: true,
    definition: 'Psychiatric Mental Health Nurse Practitioner',
  },
  'PMHNP FNP DNP': {
    show: true,
    definition:
      'Psychiatric Mental Health Nurse Practitioner, Family Nurse Practitioner, Doctor of Nursing Practice',
  },
  'PMHNP FNP': {
    show: true,
    definition:
      'Psychiatric Mental Health Nurse Practitioner, Family Nurse Practitioner',
  },
  'PMHNP DNP': {
    show: true,
    definition:
      'Psychiatric Mental Health Nurse Practitioner, Doctor of Nursing Practice',
  },
  'PMHNP MEd': {
    show: true,
    definition:
      'Psychiatric Mental Health Nurse Practitioner, Master of Education',
  },
  'PMHNP PhD': {
    show: true,
    definition:
      'Psychiatric Mental Health Nurse Practitioner, Doctor of Philosophy',
  },
  'Psy.D': {
    show: true,
    definition: 'Doctor of Psychology',
  },
  'Psychiatry NP': {
    show: true,
    definition: 'Psychiatric Nurse Practitioner',
  },
  'Psychiatry PMHNP': {
    show: true,
    definition: 'Psychiatric Mental Health Nurse Practitioner',
  },
  Psychologist: {
    show: false,
    definition: 'Psychologist',
  },
  'Registered Mental Health Intern': {
    show: false,
    definition: 'Counselor',
  },
  'Registered Social Worker Intern': {
    show: false,
    definition: 'Counselor',
  },
  Resident: {
    show: false,
    definition: 'Counselor',
  },
  'Resident In Counseling': {
    show: false,
    definition: 'Counselor',
  },
  Supervisee: {
    show: false,
    definition: 'Supervisee',
  },
  'Supervisee (LCSW - In process)': {
    show: false,
    definition: 'Supervisee (LCSW - In Process)',
  },
  'Supervisee (LSW)': {
    show: false,
    definition: 'Supervisee (LSW)',
  },
  'Supervisee In Counseling': {
    show: false,
    definition: 'Supervisee in Counseling',
  },
  'Supervisee in Social Work': {
    show: false,
    definition: 'Supervisee in Social Work',
  },
  ACSW: {
    show: true,
    definition: 'Associate Clinical Social Worker',
  },
  APCC: {
    show: true,
    definition: 'Associate Professional Clinical Counselor',
  },
  LLMSW: {
    show: true,
    definition: "Limited Licensed Master's Social Worker",
  },
  LLC: {
    show: true,
    definition: 'Limited Licensed Counselor',
  },
}
export default credentials
